import React from 'react';
import {invoke} from './novaInvocationStore';
import {NovaAgentPicker} from './NovaAgentPicker';

export interface NovaAgentPickerForTaskProps {
	taskId: string;
	// See NovaAgentPickerProps.instanceKey (NovaAgentPicker.tsx) — must match whatever key the
	// sibling ConnectedNovaInvocationControl was given.
	instanceKey?: string;
	// Threaded through to invoke() for the notification a completed run may raise — this component
	// has no other way to know the task's display name.
	taskName?: string;
	// Same reasoning as taskName — lets the notification link to the task from anywhere, not just
	// the page the run started on.
	companyProjectId?: string | number;
	companyTaskId?: string | number;
	// For the notification's project-code pill — same reasoning as companyProjectId/companyTaskId.
	projectColor?: string;
}

// Deliberately no same-agent check or confirmation here, unlike ChangeAgentAffordance: this
// picker only opens from the caret while the control is in its bare `action` state (no run has
// started, nothing to lose), so every pick is a first invocation. Reusing this direct-invoke
// wrapper for a post-run "change agent" surface would skip ChangeAgentAffordance's data-loss
// warning entirely — that policy lives there, not in novaInvocationStore.invoke() itself.
export const NovaAgentPickerForTask = (props: NovaAgentPickerForTaskProps): JSX.Element => (
	<NovaAgentPicker
		taskId={props.taskId}
		instanceKey={props.instanceKey}
		onSelectAgent={agentId =>
			invoke(props.taskId, agentId, {
				taskName: props.taskName,
				companyProjectId: props.companyProjectId,
				companyTaskId: props.companyTaskId,
				projectColor: props.projectColor,
			})
		}
	/>
);
